import { render, staticRenderFns } from "./FiltersSlide.vue?vue&type=template&id=25c1981c&scoped=true"
import script from "./FiltersSlide.vue?vue&type=script&lang=js"
export * from "./FiltersSlide.vue?vue&type=script&lang=js"
import style0 from "./FiltersSlide.vue?vue&type=style&index=0&id=25c1981c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1981c",
  null
  
)

export default component.exports